import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import { ADD_TRANSACTION_PAYMENT_METHOD_NAME, METHOD_PAYTO } from 'constants';
import { FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME } from 'constants/fx';
import { PAYTO_LOG_TAG } from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useAddTransaction from 'hooks/form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import usePage from 'hooks/usePage';
import { isArray, isEmpty, isObject } from 'lodash';
import React, { useEffect, useRef } from 'react';
import withAddPaytoAccountsAgreement from './withAddPaytoAccountsAgreement';

const withPaymentMethodAutoSelect = (Component) => {
  const PaymentMethodAutoSelectComponent = withAddPaytoAccountsAgreement(
    (props) => {
      const {
        information,
        onSelect,
        checkPaymentMethodItemDisabled,
        isPaymentMethodAutoSelectManual = false,
        fetchPaytoAccountsAgreementLatest,
        isPreventPaymentMethodAutoSelect,
      } = props || {};

      const initial = useRef(true);
      const isInitial = initial.current;

      const { paytoAccountsAgreement } = usePaytoStore();
      const {
        paymentMethod: fxPaymentMethod,
        paymentMethodName,
        setPaymentMethod: setFXPaymentMethod,
        isMakePayment: isFxMakePayment,
        transactionDetails: FXTransactionDetails,
        getTotalPayAmount,
      } = useFxFormAddTransactionStore();
      const {
        paymentMethod: toPaymentMethod,
        paymentMethod,
        setPaymentMethod: setTOPaymentMethod,
        paytoAccountInformation,
        isMakePayment: isToMakePayment,
        transactionDetails: TOTransactionDetails,
      } = useFormAddTransactionStore();
      const { isAddTransactionPage, isFxAddTransactionPage } = usePage();
      const { getTotalToPay } = useAddTransaction();

      const totalToPay = isAddTransactionPage
        ? getTotalToPay()
        : getTotalPayAmount();

      const toAccountAgreementMakePayment = paytoAccountsAgreement?.find(
        (accountAgreement) =>
          accountAgreement?.paymentAgreementUID ===
            TOTransactionDetails?.paytoAgreement?.paymentAgreementUID &&
          TOTransactionDetails?.paytoAgreement?.maxAmount >= totalToPay
      );
      const fxAccountAgreementMakePayment = paytoAccountsAgreement?.find(
        (accountAgreement) =>
          accountAgreement?.paymentAgreementUID ===
            FXTransactionDetails?.paytoAgreement?.paymentAgreementUID &&
          FXTransactionDetails?.paytoAgreement?.maxAmount >= totalToPay
      );

      const isPaytoBlocked =
        !isEmpty(paytoAccountsAgreement) &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );

      const handleFXPaymentMethodAutoSelect = (
        paymentMethod,
        accountAgreement = null
      ) => {
        if (!isFxAddTransactionPage) return;
        if (paymentMethod) {
          const newInformation = {
            ...(!isEmpty(information) && isObject(information)
              ? information
              : fxPaymentMethod),
            [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: paymentMethod,
          };
          setFXPaymentMethod(newInformation);
          onSelect(accountAgreement);
        } else {
          const newInformation = {
            ...(!isEmpty(information) && isObject(information)
              ? information
              : fxPaymentMethod),
            [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
          };
          setFXPaymentMethod(newInformation);
        }
      };

      const handleTOPaymentMethodAutoSelect = (
        paymentMethod,
        accountAgreement = null
      ) => {
        if (!isAddTransactionPage) return;
        if (paymentMethod) {
          const newInformation = {
            ...(!isEmpty(information) && isObject(information)
              ? information
              : toPaymentMethod),
            [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: paymentMethod,
          };
          setTOPaymentMethod(newInformation);
          onSelect(accountAgreement);
        } else {
          const newInformation = {
            ...(!isEmpty(information) && isObject(information)
              ? information
              : toPaymentMethod),
            [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
          };
          setTOPaymentMethod(newInformation);
          if (isToMakePayment && isEmpty(toAccountAgreementMakePayment)) {
            onSelect();
          }
        }
      };

      useEffect(() => {
        if (IS_PAYTO_CONFIG_DISABLE) return;
        if (isPaymentMethodAutoSelectManual) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ isPaymentMethodAutoSelectManual ↩`,
            isPaymentMethodAutoSelectManual
          );
          return;
        }
        if (!isFxAddTransactionPage) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ isFxAddTransactionPage ↩`,
            isFxAddTransactionPage
          );
          return;
        }
        if (
          !isFxMakePayment &&
          !paymentMethodName &&
          checkPaymentMethodItemDisabled(METHOD_PAYTO)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ RESET 3 ↩`
          );
          handleFXPaymentMethodAutoSelect();
          return;
        }
        if (!isInitial) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ isInitial ↩`,
            isInitial
          );
          if (
            !paymentMethodName &&
            !isEmpty(paytoAccountsAgreement) &&
            !isPaytoBlocked
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO SELECT 1 ↩`
            );
            handleFXPaymentMethodAutoSelect(METHOD_PAYTO);
            return;
          }
          if (
            isFxMakePayment &&
            paymentMethodName === METHOD_PAYTO &&
            !isEmpty(paytoAccountsAgreement) &&
            !isEmpty(fxAccountAgreementMakePayment)
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO SELECT 2 ↩`
            );
            if (isPaytoBlocked) {
              handleFXPaymentMethodAutoSelect();
            } else {
              handleFXPaymentMethodAutoSelect(
                METHOD_PAYTO,
                fxAccountAgreementMakePayment
              );
            }
            return;
          }
          if (
            paymentMethodName === METHOD_PAYTO &&
            !isEmpty(paytoAccountsAgreement) &&
            isPaytoBlocked
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO RESET ↩`
            );
            handleFXPaymentMethodAutoSelect();
            return;
          }
          if (
            isFxMakePayment &&
            paymentMethodName === METHOD_PAYTO &&
            isEmpty(paytoAccountsAgreement)
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO RESET 1 ↩`
            );
            handleFXPaymentMethodAutoSelect();
            return;
          }
          return;
        }
        if (
          paymentMethodName === METHOD_PAYTO &&
          isEmpty(paytoAccountsAgreement)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ RESET 1 ↩`
          );
          handleFXPaymentMethodAutoSelect();
          return;
        }
        initial.current = false;
        if (isPaytoBlocked) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ RESET 2 ↩`
          );
          handleFXPaymentMethodAutoSelect(paymentMethodName);
          return;
        }
        if (paymentMethodName) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ paymentMethodName ↩`,
            paymentMethodName
          );
          return;
        }
        if (!isEmpty(paytoAccountsAgreement)) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO SELECT 3 ↩`
          );
          handleFXPaymentMethodAutoSelect(METHOD_PAYTO);
          return;
        }
        if (
          isFxMakePayment &&
          paymentMethodName === METHOD_PAYTO &&
          isEmpty(paytoAccountsAgreement)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ FX ➡️ AUTO SELECT 4 ↩`
          );
          fetchPaytoAccountsAgreementLatest((accountAgreements) => {
            if (!isEmpty(accountAgreements)) {
              handleFXPaymentMethodAutoSelect(METHOD_PAYTO);
            }
          });
          return;
        }
      }, [
        paymentMethodName,
        paytoAccountsAgreement,
        isPaytoBlocked,
        isFxMakePayment,
        fxAccountAgreementMakePayment,
      ]);

      useEffect(() => {
        if (IS_PAYTO_CONFIG_DISABLE) return;
        if (isPaymentMethodAutoSelectManual) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ isPaymentMethodAutoSelectManual ↩`,
            isPaymentMethodAutoSelectManual
          );
          return;
        }
        if (!isAddTransactionPage) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ isAddTransactionPage ↩`,
            isAddTransactionPage
          );
          return;
        }
        if (
          !isToMakePayment &&
          !paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] &&
          checkPaymentMethodItemDisabled(METHOD_PAYTO)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ RESET 3 ↩`
          );
          if (isPreventPaymentMethodAutoSelect) return;
          handleTOPaymentMethodAutoSelect();
          return;
        }
        if (!isInitial) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ isInitial ↩`,
            isInitial
          );
          if (
            !paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] &&
            !isEmpty(paytoAccountsAgreement) &&
            !isPaytoBlocked
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO SELECT 1 ↩`
            );
            handleTOPaymentMethodAutoSelect(METHOD_PAYTO);
            return;
          }
          if (
            isToMakePayment &&
            paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] ===
              METHOD_PAYTO &&
            !isEmpty(paytoAccountsAgreement) &&
            !isEmpty(toAccountAgreementMakePayment)
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO SELECT 2 ↩`
            );
            if (isPaytoBlocked) {
              handleTOPaymentMethodAutoSelect();
            } else {
              handleTOPaymentMethodAutoSelect(
                METHOD_PAYTO,
                toAccountAgreementMakePayment
              );
            }
            return;
          }
          if (
            paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] ===
              METHOD_PAYTO &&
            !isEmpty(paytoAccountsAgreement) &&
            isPaytoBlocked
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO RESET ↩`
            );
            handleTOPaymentMethodAutoSelect();
            return;
          }
          if (
            isToMakePayment &&
            paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] ===
              METHOD_PAYTO &&
            isEmpty(paytoAccountsAgreement)
          ) {
            console.log(
              `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO RESET 1 ↩`
            );
            handleTOPaymentMethodAutoSelect();
            return;
          }
          return;
        }
        if (
          paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] ===
            METHOD_PAYTO &&
          isEmpty(paytoAccountsAgreement)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ RESET 1 ↩`
          );
          handleTOPaymentMethodAutoSelect();
          return;
        }
        initial.current = false;
        if (isPaytoBlocked) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ RESET 2 ↩`
          );
          handleTOPaymentMethodAutoSelect(
            paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME]
          );
          return;
        }
        if (paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME]) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ paymentMethodName ↩`,
            paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME]
          );
          return;
        }
        if (!isEmpty(paytoAccountsAgreement)) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO SELECT 3 ↩`
          );
          handleTOPaymentMethodAutoSelect(METHOD_PAYTO);
          return;
        }
        if (
          isToMakePayment &&
          paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] ===
            METHOD_PAYTO &&
          isEmpty(paytoAccountsAgreement)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withPaymentMethodAutoSelect ➡️ TO ➡️ AUTO SELECT 4 ↩`
          );
          fetchPaytoAccountsAgreementLatest((accountAgreements) => {
            if (!isEmpty(accountAgreements)) {
              handleTOPaymentMethodAutoSelect(METHOD_PAYTO);
            }
          });
          return;
        }
      }, [
        paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME],
        paytoAccountsAgreement,
        isPaytoBlocked,
        isToMakePayment,
        toAccountAgreementMakePayment,
        isPreventPaymentMethodAutoSelect,
      ]);

      const newProps = {
        ...props,
        handleFXPaymentMethodAutoSelect,
        handleTOPaymentMethodAutoSelect,
      };
      return <Component {...newProps} />;
    }
  );
  return PaymentMethodAutoSelectComponent;
};

export default withPaymentMethodAutoSelect;
